var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M19.902 1.591a3.75 3.75 0 0 0-5.304 0L9.091 7.098a3.75 3.75 0 0 0 0 5.304l2.379 2.378 1.06-1.06-2.378-2.379a2.25 2.25 0 0 1 0-3.182l5.507-5.507a2.25 2.25 0 0 1 3.182 0l2.507 2.507a2.25 2.25 0 0 1 0 3.182L17.47 12.22l1.06 1.06 3.879-3.878a3.75 3.75 0 0 0 0-5.304z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M14.909 11.598 12.53 9.22l-1.06 1.06 2.378 2.379a2.25 2.25 0 0 1 0 3.182l-5.507 5.507a2.25 2.25 0 0 1-3.182 0l-2.507-2.507a2.25 2.25 0 0 1 0-3.182L6.53 11.78l-1.06-1.06-3.879 3.878a3.75 3.75 0 0 0 0 5.304l2.507 2.507a3.75 3.75 0 0 0 5.304 0l5.507-5.507a3.75 3.75 0 0 0 0-5.304"
})));
export default SvgCopyLink;